import React, { useState, useRef, useEffect } from "react";
import logo from "../images/why-me-logo.svg";
import { Link } from "react-router-dom";
import "../App.css";

const Header = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLinkClick = () => {
    setDropdownOpen(false);
  };

  return (
    <header className="bg-[#13689b] shadow-md">
      <div className="container mx-auto px-4 py-6 flex justify-between items-center">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src={logo}
            alt="Why Me Solutions"
            className="h-auto w-auto max-h-12 max-w-full ml-12 logo"
          />
        </Link>
        <nav className="hidden md:flex space-x-6 font-semibold">
          <Link
            to="/"
            className="text-white hover:text-black transition duration-300"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="text-white hover:text-black transition duration-300"
          >
            About
          </Link>
          <div className="relative" ref={dropdownRef}>
            <button
              className="text-white hover:text-black transition duration-300"
              onClick={() => setDropdownOpen(!isDropdownOpen)}
            >
              Services
            </button>
            {isDropdownOpen && (
              <div className="absolute -left-12 top-full bg-white text-black shadow-lg rounded-md mt-2 py-2 w-48 z-50">
                <Link
                  to="/marketing-services"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Marketing Services
                </Link>
                <Link
                  to="/it-services"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  IT Services
                </Link>
                <Link
                  to="/hr-services"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  HR Services
                </Link>
                <Link
                  to="/finance-services"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Finance Services
                </Link>
              </div>
            )}
          </div>
          <Link
            to="/contact"
            className="text-white hover:text-black transition duration-300"
          >
            Contact
          </Link>
        </nav>
        <div className="md:hidden flex items-center">
          <button
            className="text-white focus:outline-none focus:text-black"
            onClick={() =>
              document.getElementById("mobile-menu").classList.toggle("hidden")
            }
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div id="mobile-menu" className="hidden md:hidden text-center">
        <Link
          to="/"
          className="block text-white hover:bg-black transition duration-300 px-4 py-2"
        >
          Home
        </Link>
        <Link
          to="/about"
          className="block text-white hover:bg-black transition duration-300 px-4 py-2"
        >
          About
        </Link>
        <div className="relative flex flex-col" ref={dropdownRef}>
          <button
            className="block text-white hover:bg-black transition duration-300 px-4 py-2"
            onClick={() => setDropdownOpen(!isDropdownOpen)}
          >
            Services
          </button>
          {isDropdownOpen && (
            <div className="bg-white text-black shadow-lg rounded-md py-2 w-full z-50">
              <Link
                to="/marketing-services"
                className="block px-4 py-2 hover:bg-gray-100"
                onClick={handleLinkClick}
              >
                Marketing Services
              </Link>
              <Link
                to="/it-services"
                className="block px-4 py-2 hover:bg-gray-100"
                onClick={handleLinkClick}
              >
                IT Services
              </Link>
              <Link
                to="/hr-services"
                className="block px-4 py-2 hover:bg-gray-100"
                onClick={handleLinkClick}
              >
                HR Services
              </Link>
              <Link
                to="/finance-services"
                className="block px-4 py-2 hover:bg-gray-100"
                onClick={handleLinkClick}
              >
                Finance Services
              </Link>
            </div>
          )}
        </div>
        <Link
          to="/contact"
          className="block text-white hover:bg-black transition duration-300 px-4 py-2"
        >
          Contact
        </Link>
      </div>
    </header>
  );
};

export default Header;
